export default class Role {
  public id: number = -1
  public name: string = ''
  public ad_group_regex: string = ''
  public is_managed: boolean = true
  public permissions: number[] = []
  public school_id: number | null = null

  constructor(
    id: number,
    name: string,
    ad_group_regex: string,
    permissions: number[],
    school_id: number,
  ) {
    this.id = id
    this.name = name
    this.ad_group_regex = ad_group_regex
    this.is_managed = true
    this.permissions = permissions
    this.school_id = school_id
  }
}
